<template>
  <div>
    <div class="wrapper wrapper-full-page">
      <div class="full-page" :class="pageClass">
        <div class="content">
          <router-view :key="$route.fullPath"></router-view>
        </div>
        <footer class="footer">
          <div class="container-fluid">
            <div class="copyright">&copy; 2020, Space Oddity Inc., All rights reserved.</div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      showMenu: false,
      pageClass: "login-page",
    };
  },
};
</script>
<style></style>
